

<div class="row">
  <div class="col-md-10 col-10">
    <h3 mat-dialog-title >{{  'PleaseSelectModificationType' | translate  }}</h3>
  </div>
  <div class="col-md-2 col-2 p-0">
      <button mat-dialog-action class="btnLink closeModal text-right" (click)="close()"> <fa-icon [icon]="faTimesCircle"></fa-icon></button>
  </div>
</div>

<mat-dialog-content>

  <div class="row mt-3 modification-modal">
    <div class="col-md-12">
      <div class="form-group">
        <mat-radio-group class="d-flex flex-column">
          <mat-radio-button (change)="ModifyPickup()"  class="mb-2" value="ModifyPickup">
            {{  'ModifyPickupOrReturnDateOrLocation' | translate  }}
          </mat-radio-button>
          <mat-radio-button (change)="AddRemoveExtras()" class="mb-2" value="AddRemoveExtras">
            {{  'Add/RemoveExtras' | translate  }}
          </mat-radio-button>
       <!--    <mat-radio-button (change)="UpdateAdditional()" class="mb-2" value="UpdateAdditional" *ngIf="isHavingAdditionalDriver">
            {{  'UpdateAdditionalDriverInformation' | translate  }}
          </mat-radio-button> -->
        </mat-radio-group>
      </div>
    </div>
    <div class="col-md-12">
      <button class="btn default-btn mr-3" mat-button>{{ 'Confirm' | translate }}</button>
      <button (click)="close()" class="btn default-cancel-btn" mat-button>{{ 'Cancel' | translate }}</button>
    </div>
  </div>

</mat-dialog-content>
